import { Injectable } from "@angular/core";
import { FirebaseCredential } from "../models/firebase/FirebaseCredential";
import { SMBrand } from "../models/SMBrand";
import { SMBrandOwner } from "../models/SMBrandOwner";
import { AppAuthService } from "../services/auth.service";
import { BrandOwnerService } from "../services/crud/brand-owner.service";
import { BrandService } from "../services/crud/brand.service";

@Injectable()
export class AppServices {

    constructor(private authService: AppAuthService, private brandOwnerService: BrandOwnerService, private brandService: BrandService) { }

    async login(username: string, password: string): Promise<FirebaseCredential> {
        return await this.authService.signInWithCredentials(username, password);
    }

    async loadCurrentUser(): Promise<FirebaseCredential> {
        return await this.authService.loadCurrentUser();
    }

    async loadCurrentUserData(id: string): Promise<SMBrandOwner> {
        return await this.brandOwnerService.getOwnerFromFirebaseWithId(id);
    }

    async loadCurrentBrandData(id: string): Promise<SMBrand> {
        return await this.brandService.getBrandFromFirebase(id);
    }

    async loadAllBrandData() {
        return await this.brandService.getAllBrands();
    }

    async createBrandOwnerFirebaseAuth(brandOwner: string, password: string): Promise<FirebaseCredential>{
        return await this.authService.createUserEmailAndPassword(brandOwner, password);
    }

    async createBrandOwner(brandOwner: SMBrandOwner): Promise<any> {
        return await this.brandOwnerService.createOwner(brandOwner);
    }

    async createBrand(newBrand: SMBrand): Promise<SMBrand> {
        return await this.brandService.createBrand(newBrand);
    }

    async updateBrandOwner(brandOwner: SMBrandOwner): Promise<SMBrandOwner> {
        const result = await this.brandOwnerService.updateOwner(brandOwner);

        if(result) {
            return await this.loadCurrentUserData(brandOwner.id);
        }
        
        return {...brandOwner}
        
    }

    async loadTempBrandOwnerData(brandID): Promise<SMBrandOwner> {

        return await this.brandOwnerService.getBrandOwnerWithBrandID(brandID);
    }
    
    async updateBrand(brand: SMBrand): Promise<void> {
        const result = await this.brandService.updateBrand(brand);
    }
}